var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#808085",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM11.9936 16.1885C14.3791 15.4207 16.1629 13.3119 16.4572 10.75H13.7277C13.6061 12.7777 12.9926 14.6168 11.9936 16.1885ZM8.00635 16.1885C5.62093 15.4207 3.83713 13.3119 3.5428 10.75H6.27233C6.39388 12.7777 7.00736 14.6168 8.00635 16.1885ZM7.7754 10.75C7.92487 12.938 8.72724 14.8513 10 16.3816C11.2728 14.8513 12.0751 12.938 12.2246 10.75H7.7754ZM12.2246 9.25H7.7754C7.92486 7.06203 8.72724 5.14867 10 3.61833C11.2728 5.14867 12.0751 7.06203 12.2246 9.25ZM13.7277 9.25H16.4572C16.1629 6.68813 14.3791 4.57934 11.9937 3.81146C12.9926 5.38325 13.6061 7.22234 13.7277 9.25ZM8.00633 3.81146C7.00735 5.38325 6.39387 7.22234 6.27233 9.25H3.5428C3.83713 6.68813 5.62092 4.57934 8.00633 3.81146Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.cfb4e145.svg";
export { ForwardRef as ReactComponent };